module.exports = __webpack_public_path__ + "static/bg.85126b4d.png";